import styled from '@emotion/styled';

const SidebarPanelEmpty = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.theme.gray300};
  height: 100%;
  width: 100%;
  padding: 0 60px;
  text-align: center;
`;

export default SidebarPanelEmpty;
